/** Soat widgeti sozlamasi. Backend tekshiruvi bilan bir xil (apps/widgets/registry.py, clean_clock). */
import type { Me } from "@/features/auth/types";
import { isValidZone } from "./time";

export interface ClockZone {
  tz: string;
  /** Bo'sh -- shahar nomi */
  label: string;
}

export interface ClockConfig {
  zones: ClockZone[];
  seconds: boolean;
  /** null -- til bo'yicha (autoHour12) */
  hour12: boolean | null;
  /** Qo'ng'iroq vaqti, zona mahalliy soatida: [boshlanish, tugash) */
  call: [number, number];
}

export const MAX_ZONES = 6;
export const LABEL_MAX = 24;
const US_DEFAULT = ["America/New_York", "America/Chicago", "America/Los_Angeles"];

export function defaultClockConfig(me: Pick<Me, "timezone">): ClockConfig {
  const own = me.timezone || "Asia/Tashkent";
  const zones = US_DEFAULT.includes(own) ? [...US_DEFAULT, "America/Denver"] : [...US_DEFAULT, own];
  return { zones: zones.map((tz) => ({ tz, label: "" })), seconds: true, hour12: null, call: [9, 20] };
}

export function parseClockConfig(raw: unknown, me: Pick<Me, "timezone">): ClockConfig {
  const fallback = defaultClockConfig(me);
  if (!raw || typeof raw !== "object") return fallback;
  const r = raw as Record<string, unknown>;
  const zones = Array.isArray(r.zones)
    ? r.zones
        .filter((z): z is { tz: string; label?: unknown } => !!z && typeof z === "object" && isValidZone((z as { tz?: unknown }).tz))
        .slice(0, MAX_ZONES)
        .map((z) => ({ tz: z.tz, label: typeof z.label === "string" ? z.label.slice(0, LABEL_MAX) : "" }))
    : [];
  const call = Array.isArray(r.call) && r.call.length === 2 && r.call.every((h) => Number.isInteger(h)) && 0 <= r.call[0] && r.call[0] < r.call[1] && r.call[1] <= 24
    ? ([r.call[0], r.call[1]] as [number, number])
    : fallback.call;
  return {
    zones: zones.length ? zones : fallback.zones,
    seconds: typeof r.seconds === "boolean" ? r.seconds : fallback.seconds,
    hour12: typeof r.hour12 === "boolean" ? r.hour12 : null,
    call,
  };
}
